import { render } from "./TheL04Header.vue?vue&type=template&id=df468018&scoped=true&ts=true"
import script from "./TheL04Header.vue?vue&type=script&lang=ts"
export * from "./TheL04Header.vue?vue&type=script&lang=ts"

import "./TheL04Header.vue?vue&type=style&index=0&id=df468018&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df468018"]])

export default __exports__